import * as tslib_1 from "tslib";
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { lazyLoadSearchTable } from 'owa-mail-execute-search-actions';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { resetFocus } from 'owa-mail-focus-manager';
import { getIsSearchTableShown, getSelectedTableView } from 'owa-mail-list-store';
import { exitSearch, lazyCloseImmersiveReadingPane } from 'owa-mail-module-orchestrator';
import { SearchBox } from 'owa-mail-search-view';
import mailModuleStore from 'owa-mail-store/lib/store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { lazyEndSearchSession, lazyStartSearch, lazyStartSearchSession, } from 'owa-mail-search-actions';
import { lazySetShowFiltersMenu, searchStore, lazySetSearchTextForSuggestion, getSearchScenarioType, } from 'owa-mail-search-store';
var MailSearchBoxComputedState = /** @class */ (function () {
    function MailSearchBoxComputedState() {
    }
    Object.defineProperty(MailSearchBoxComputedState.prototype, "isReadingPanePositionRight", {
        get: function () {
            return (getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
                ReadingPanePosition.Right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailSearchBoxComputedState.prototype, "isImmersiveReadingPaneShown", {
        get: function () {
            return (getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
                ReadingPanePosition.Off && mailModuleStore.mailModule.showReadingPane);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailSearchBoxComputedState.prototype, "isSearchTableShown", {
        get: function () {
            return getIsSearchTableShown();
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], MailSearchBoxComputedState.prototype, "isReadingPanePositionRight", null);
    tslib_1.__decorate([
        computed
    ], MailSearchBoxComputedState.prototype, "isImmersiveReadingPaneShown", null);
    tslib_1.__decorate([
        computed
    ], MailSearchBoxComputedState.prototype, "isSearchTableShown", null);
    return MailSearchBoxComputedState;
}());
var MailSearchBoxContainer = /** @class */ (function (_super) {
    tslib_1.__extends(MailSearchBoxContainer, _super);
    function MailSearchBoxContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onEscape = function (evt) {
            // If we are in search mode honour the escape key press
            // Search box could be hidden in certain scenarios even in search mode,
            // in which case this is a no-op
            if (_this.computedState.isSearchTableShown) {
                evt.stopPropagation();
                exitSearch('Keyboard');
            }
        };
        _this.onRefinersDismissed = function () {
            /**
             * If search table is shown, call resetFocus to properly give focus
             * back to the search table. Otherwise, the search box input will
             * take focus so user can input a query.
             */
            if (_this.computedState.isSearchTableShown) {
                resetFocus();
            }
        };
        _this.onFolderFilterClick = function () {
            lazySetShowFiltersMenu.importAndExecute(!searchStore.showFiltersMenu);
        };
        _this.onSearchBoxFocused = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var searchBoxControl, startSearchSession;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchBoxControl = this.searchBoxControl.getInnerComponent();
                        return [4 /*yield*/, lazyStartSearchSession.import()];
                    case 1:
                        startSearchSession = _a.sent();
                        /**
                         * If the search box has focus or the control is not empty, we'll fire
                         * a request to get search suggestions. Prior to firing that request,
                         * we'll also start the search session if it's not started already.
                         */
                        if (searchBoxControl.hasFocus() || !searchBoxControl.isEmpty()) {
                            if (!searchStore.searchSessionGuid) {
                                startSearchSession();
                            }
                            /**
                             * This is called to ensure that the searchTextForSuggestion matches
                             * the current searchText. They can be different if the user selected
                             * a suggestion via the keyboard in the previous search.
                             */
                            if (searchBoxControl.hasFocus()) {
                                lazySetSearchTextForSuggestion.importAndExecute(searchStore.searchText);
                            }
                        }
                        // Pre-import lazy search operations needed for making requests for query and suggestions, because if we do not,
                        // the first import will go through a promise resolve, delaying the search request from going out, even if the
                        // script file is loaded in the DOM
                        lazyLoadSearchTable.import();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onSearchBoxBlurred = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var searchBoxControl;
            return tslib_1.__generator(this, function (_a) {
                searchBoxControl = this.searchBoxControl.getInnerComponent();
                if (searchStore.searchSessionGuid &&
                    !this.computedState.isSearchTableShown &&
                    (searchBoxControl.isEmpty() && !searchBoxControl.hasFocus())) {
                    // End search session when
                    // We are in session AND
                    // Not showing search results AND
                    // Focus is not in search box AND
                    // Search box is empty
                    lazyEndSearchSession();
                }
                return [2 /*return*/];
            });
        }); };
        _this.onSearch = function (actionSource) {
            lazyStartSearch(actionSource);
        };
        _this.onBackClick = function () {
            if (_this.computedState.isImmersiveReadingPaneShown &&
                getSearchScenarioType(getSelectedTableView().tableQuery) !== 'messageSuggestion') {
                // If we are in immersive reading pane then close immersive reading pane
                lazyCloseImmersiveReadingPane.importAndExecute();
            }
            else {
                // Else exit search
                exitSearch('SearchBoxBackArrow');
            }
        };
        _this.computedState = new MailSearchBoxComputedState();
        return _this;
    }
    /**
     * Sets/puts focus on the search input
     */
    MailSearchBoxContainer.prototype.setFocus = function () {
        this.searchBoxControl.getInnerComponent().setFocus();
    };
    MailSearchBoxContainer.prototype.render = function () {
        var _this = this;
        var userConfiguration = getUserConfiguration();
        var globalFolderViewState = JSON.parse(userConfiguration.ViewStateConfiguration.GlobalFolderViewState || '{}');
        // Search box width should match list view in 3 column
        var searchBoxMaxWidthValue = this.computedState.isReadingPanePositionRight
            ? globalFolderViewState.Width
            : null;
        var backButtonTitle = this.computedState.isImmersiveReadingPaneShown
            ? strings.backSearchResults
            : strings.exitSearchTitle;
        return (React.createElement(SearchBox, { ref: function (ref) { return (_this.searchBoxControl = ref); }, disabled: this.props.disabled, backButtonTitle: backButtonTitle, onSearch: this.onSearch, areSearchResultsShown: this.computedState.isSearchTableShown, onFocused: this.onSearchBoxFocused, onBlurred: this.onSearchBoxBlurred, customCollapsedMaxWidth: searchBoxMaxWidthValue, onBackClick: this.onBackClick, onFolderFilterClick: this.onFolderFilterClick, shouldShowPinSearchIcon: isMailFeatureEnabled('sea-pin'), onRefinersDismissed: this.onRefinersDismissed }));
    };
    MailSearchBoxContainer = tslib_1.__decorate([
        observer
    ], MailSearchBoxContainer);
    return MailSearchBoxContainer;
}(React.Component));
export default MailSearchBoxContainer;
//# sourceMappingURL=MailSearchBoxContainer.js.map